import { useState } from "react";
import { Link } from "react-router-dom";
import { useClientSelection } from "../client-context";
import { ErrorState, LoadingState } from "./Ui";
import { BrightLocalLinks } from "./BrightLocalSetup";

/** Connect a client where the agency key is configured, without a sidebar detour. */
export default function BrightLocalConnect() {
  const { clients } = useClientSelection();
  const [selected, setSelected] = useState("");
  const client = clients.data?.find((c) => String(c.id) === selected);

  return (
    <section className="bl-connect" aria-label="Connect BrightLocal to a client">
      <h4>Connect a client</h4>
      <p className="muted">Choose a NOLA client, then link the BrightLocal locations that belong to it. You can connect them right here.</p>
      {clients.loading ? <LoadingState label="Loading clients" />
        : clients.error ? <ErrorState message={clients.error} onRetry={clients.reload} />
        : <label className="bl-connect-picker">
            Client to connect
            <select value={selected} onChange={(event) => setSelected(event.target.value)}>
              <option value="">Choose a client</option>
              {clients.data?.map((c) => <option key={c.id} value={c.id}>{c.name} · #{c.id}</option>)}
            </select>
          </label>}
      {client && <>
        <p className="muted">Linking locations to <strong>{client.name}</strong>. Only choose locations owned by this client.</p>
        <Link className="button secondary" to={`/client-settings?client_id=${client.id}&section=brightlocal`}>Open this client's BrightLocal settings</Link>
        <BrightLocalLinks key={client.id} clientId={client.id} />
      </>}
      {!clients.loading && !clients.error && clients.data?.length === 0 && <p>No clients are available to connect.</p>}
    </section>
  );
}
